import { BaseChartOptions, HoldConfig } from "../types";

export const SVG_NS = "http://www.w3.org/2000/svg";
export const RESERVED_KEYS = new Set(["label"]);
export const FRAME_LABEL_VERTICAL_SPACE = 48;
export const KEY_LABEL_VERTICAL_SPACE = 32;

export const defaultHold: Required<HoldConfig> = {
  start: 0,
  end: 0,
};

export const defaultOptions: Required<BaseChartOptions> = {
  width: 640,
  height: 360,
  padding: 0,
  labels: true,
  labelFontSize: 24,
  valueLabels: false,
  valueLabelPrefix: "",
  valueLabelSuffix: "",
  sort: "none",
  animateEach: true,
  chartType: "bar",
  duration: 3000,
  advanceDelay: 0,
  easing: "ease",
  loopMode: "normal",
  iterations: "infinite",
  stagger: 0,
  hold: defaultHold,
  dataItemStyle: "solid",
  innerRadius: 0,
  startAngle: -90,
  labelOffset: 12,
};
